import { BUBBLETAP_TEL, supportEmail } from '@repo/constants';

import * as Styled from '../../policy.styled';

export default function YouthProtectionPolicyTh() {
  const SUPPORT_EMAIL = supportEmail('th');
  return (
    <Styled.MainWrapper>
      <h3 style={{ marginBottom: '40px' }}>นโยบายคุ้มครองเยาวชนของบริษัท บับเบิ้ลแท็ป จำกัด</h3>
      บริษัท บับเบิ้ลแท็ป จำกัด (ต่อไปนี้เรียกว่า “บริษัท”)
      ตระหนักถึงความสำคัญของการดูแลเยาวชนให้สามารถใช้งานอินเทอร์เน็ตได้อย่างปลอดภัยและเหมาะสม
      บริษัทจึงดำเนินนโยบายการคุ้มครองเยาวชนตามพระราชบัญญัติส่งเสริมการใช้เครือข่ายสารสนเทศและการคุ้มครองข้อมูล
      เพื่อสร้างสภาพแวดล้อมที่ปลอดภัยสำหรับเยาวชน ดังรายละเอียดต่อไปนี้
      <p>ข้อที่ 1 เป้าหมาย และหลักการพื้นฐานในการคุ้มครองเยาวชน</p>
      บริษัทมุ่งมั่นที่ป้องกันเยาวชนจากสภาพแวดล้อมที่เป็นอันตรายต่อร่างกายและจิตใจ และส่งเสริมการเติบโตอย่างเหมาะสม
      โดยให้บริการที่เอื้อต่อการใช้งานอินเทอร์เน็ตอย่างปลอดภัย ภายใต้การกำหนดนโยบายคุ้มครองเยาวชนไว้อย่างชัดเจน
      <p>ข้อที่ 2 มาตรการจัดการ และป้องกันการเข้าถึงข้อมูลที่เป็นอันตรายต่อเยาวชน</p>
      บริษัทมีมาตรการป้องกันเยาวชนจากเนื้อหาที่ไม่เหมาะสม โดยใช้ระบบยืนยันอายุ
      และจำกัดสิทธิ์การเข้าถึงสำหรับเนื้อหาที่จัดว่าเป็นสื่อสำหรับผู้ใหญ่ หรือสื่อที่อาจเป็นอันตรายต่อเยาวชน
      อีกทั้งยังมีการจำกัดสิทธิ์การเข้าถึงอย่างเหมาะสม นอกจากนี้ บริษัทดำเนินการตรวจสอบและจัดการเนื้อหาอย่างต่อเนื่อง
      เพื่อป้องกันการเผยแพร่ข้อมูลที่ผิดกฎหมายหรือเป็นอันตรายต่อเยาวชน
      <p>ข้อที่ 3 การให้คำปรึกษาและรับเรื่องร้องเรียนเกี่ยวข้องกับเนื้อหาที่ไม่เหมาะสม</p>
      บริษัทมีเจ้าหน้าที่ผู้เชี่ยวชาญที่พร้อมให้คำปรึกษา และรับเรื่องร้องเรียนในกรณีที่มีการเผยแพร่
      หรือเข้าถึงเนื้อหาที่ไม่เหมาะสม โดยผู้ใช้บริการสามารถติดต่อเจ้าหน้าที่ผู้รับผิดชอบได้ตามข้อมูลที่ระบุไว้ด้านล่าง
      ทั้งนี้ หากเรื่องใดเกินขอบเขตอำนาจของบริษัท บริษัทจะประสานงานหรือแนะนำหน่วยงานที่เกี่ยวข้องต่อไป
      <p>ข้อที่ 4 การให้ความรู้เพื่อคุ้มครองเยาวชนจากเนื้อหาที่ไม่เหมาะสม</p>
      บริษัทให้การอบรมแก่เจ้าหน้าที่ที่รับผิดชอบด้านการคุ้มครองเยาวชน รวมถึงเจ้าหน้าที่ดูแลบริการแต่ละประเภท
      โดยเนื้อหาในการอบรมรวมถึงกฎหมายที่เกี่ยวข้อง มาตรการควบคุม การรับมือเมื่อตรวจพบเนื้อหาที่เป็นอันตราย
      และขั้นตอนการรายงานกรณีที่พบการละเมิด
      <p>ข้อที่ 5 การแต่งตั้งเจ้าหน้าที่ผู้รับผิดชอบการคุ้มครองเยาวชน</p>
      บริษัทได้แต่งตั้งเจ้าหน้าที่คุ้มครองเยาวชนและผู้รับผิดชอบที่เกี่ยวข้องตามรายละเอียดด้านล่าง
      เพื่อดำเนินงานในการกำหนดนโยบายคุ้มครองเยาวชน ควบคุมและป้องกันการเข้าถึงข้อมูลที่เป็นอันตราย
      พร้อมทั้งสร้างสภาพแวดล้อมในการใช้งานอินเทอร์เน็ตที่ปลอดภัยและเหมาะสม
      <div className="table-wrapper">
        <table>
          <thead>
            <tr>
              <th>ประเภท</th>
              <th>ชื่อ</th>
              <th>หน่วยงาน</th>
              <th>ตำแหน่ง</th>
              <th>เบอร์โทรศัพท์</th>
              <th>ช่องทางติดต่อ</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>เจ้าหน้าที่คุ้มครองเยาวชน</td>
              <td>พัคจงบอม</td>
              <td>Bubbletap Team</td>
              <td>CEO</td>
              <td>
                <span className="tel">{BUBBLETAP_TEL}</span>
              </td>
              <td>{SUPPORT_EMAIL}</td>
            </tr>
            <tr>
              <td>เจ้าหน้าที่คุ้มครองเยาวชน</td>
              <td>พัคยองอึน</td>
              <td>Bubbletap Team</td>
              <td>ผู้อำนวยการฝ่าย</td>
              <td>
                <span className="tel">{BUBBLETAP_TEL}</span>
              </td>
              <td>{SUPPORT_EMAIL}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </Styled.MainWrapper>
  );
}
